import React, { forwardRef } from 'react';

const Badge = forwardRef(({ color = 'secondary', className = '', children, ...props }, ref) => (
  <span ref={ref} className={`status badge badge-pill badge-outline-${color} ${className}`} {...props}>
    {children}
  </span>
));

Badge.displayName = 'Badge';

export default Badge;
